const notImplemented = (methodName) => {
  return Promise.reject(`${methodName} is not implemented`);
};

class BaseCCModerationProvider {
  async getSubscriptionToken() {
    return notImplemented("getSubscriptionToken");
  }
  async featureDiscovery() {
    return notImplemented("featureDiscovery");
  }
  async sendCommand() {
    return notImplemented("sendCommand");
  }
  async subscribeToTopic() {
    return notImplemented("subscribeToTopic");
  }
  async unsubscribeFromTopic() {
    return notImplemented("unsubscribeFromTopic");
  }
  sendAnalytics() {
    return notImplemented("sendAnalytics");
  }
}

export default BaseCCModerationProvider;
